import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed, PropType} from "vue";
import {RadioItem, VARadioOptions} from "./typings";
import {useRadioGroupHandler} from "./hooks";

export default /*@__PURE__*/_defineComponent({
  __name: 'VARadioGroup',
  props: {
  value: {
    type: [String, Number, Boolean],
    required: true,
    default:()=>{
      return ""
    }
  },
  // 接收静态数据或者远程配置
  options: {
    type: Object as PropType<VARadioOptions | string[] | number[] | Array<RadioItem>>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size:{
    type: String,
  }
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {


const emits = __emit
const props = __props
const {data} = useRadioGroupHandler(props.options as VARadioOptions)

const source = computed(()=>{
  return props.options instanceof Array?props.options:data.value
})

const change = (event: any) =>{
  console.log("------------------>", event.target.value)
  emits("update:value", event.target.value)
}


return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createBlock(_component_a_radio_group, {
    "button-style": "solid",
    name: "radioGroup",
    value: __props.value,
    disabled: __props.disabled,
    size: __props.size,
    "option-type": __props.options.type,
    options: source.value,
    onChange: change
  }, null, 8, ["value", "disabled", "size", "option-type", "options"]))
}
}

})